module.exports = __webpack_public_path__ + "img/logo.524c92d5.svg";